export const teamMembers = [
  {
    id: "marjo-villarosa",
    name: "Marjo Villarosa",
    role: "Platform, Security & Data Leader",
    initials: "MV",
    linkedin: "https://www.linkedin.com/in/marjovillarosa/",
    expertise: ["API Platforms", "Identity & Auth", "Data Governance", "Security Architecture"],
    bio: "A strategic leader in platform engineering and security, focused on building robust API ecosystems and data-driven architectures. Specializes in establishing governance frameworks that ensure scalability without compromising agility."
  },
  {
    id: "maries-villarosa",
    name: "Maries Villarosa",
    role: "Program & Delivery Leader (PMP)",
    initials: "MV",
    linkedin: "https://www.linkedin.com/in/maries-villarosa-pmp",
    expertise: ["Enterprise Program Mgmt", "Stakeholder Alignment", "Agile Transformation", "Strategic Execution"],
    bio: "PMP-certified delivery expert bridging the gap between strategy and execution. Masterful at navigating complex enterprise environments to drive program success and ensure alignment across diverse stakeholder groups."
  },
  {
    id: "lotte-villarosa",
    name: "Lotte Villarosa",
    role: "Technology & Product Professional",
    initials: "LV",
    linkedin: "https://www.linkedin.com/in/lotte-villarosa",
    expertise: ["Product Strategy", "Systems Thinking", "Digital Tools", "User Experience"],
    bio: "Bridging the divide between technical capability and product vision. Leverages modern product practices and systems thinking to create digital tools that solve real-world problems with elegance and efficiency."
  },
  {
    id: "peter-villarosa",
    name: "Peter Villarosa",
    role: "Systems, Infrastructure & Ops",
    initials: "PV",
    linkedin: "https://www.linkedin.com/in/petervillarosa",
    expertise: ["Site Reliability", "Cloud Infrastructure", "Operational Continuity", "Disaster Recovery"],
    bio: "Focused on the foundational reliability of digital systems. Ensures operational continuity through resilient infrastructure design, rigorous monitoring standards, and proactive capacity planning."
  },
  {
    id: "myrna-villarosa",
    name: "Myrna Villarosa",
    role: "Digital Community & Influence Leader",
    initials: "MV",
    facebook: "https://facebook.com/myrna.villarosa.5",
    expertise: ["Community Management", "Digital Evangelism", "Content Strategy", "Audience Trust"],
    bio: "A pioneer in managing large-scale faith-based online communities. Orchestrates daily content publishing and moderation for global organizations including the Society of the Divine Word and the Perpetual Rosary Crusade."
  },
  {
    id: "joseph-villarosa",
    name: "Joseph Villarosa",
    role: "Technology Professional",
    initials: "JV",
    linkedin: "https://www.linkedin.com/in/josephvillarosa",
    expertise: ["Systems Execution", "Platform Support", "Operational Delivery", "Digital Solutions"],
    bio: "Technology professional with extensive experience in systems and digital solutions, contributing to the robust execution and operational support of enterprise platforms across diverse environments."
  },
  {
    id: "abbie-villarosa",
    name: "Abbie Villarosa",
    role: "Emerging Technology Professional",
    initials: "AV",
    linkedin: "https://www.linkedin.com/in/abbie-villarosa",
    expertise: ["Digital Coordination", "Data Analysis", "Tool Optimization", "Project Support"],
    bio: "An emerging professional focused on digital tool optimization and coordination. Strengths lie in analytical problem-solving and technology-enabled workflow execution to drive operational efficiency."
  },
  {
    id: "raimond-agraviador",
    name: "Raimond Agraviador",
    role: "Systems & Engineering Professional",
    initials: "RA",
    linkedin: "https://www.linkedin.com/in/raimond-agraviador",
    expertise: ["Software Development", "Operational Delivery", "Systems Engineering", "Technical Support"],
    bio: "Technology and engineering professional dedicated to the development and operational delivery of complex systems, ensuring high performance, technical reliability, and seamless execution."
  }
];